import { Inject, Injectable } from '@angular/core';
import { AccountGroupSdkService, AggregationSupportedFields } from '@vendasta/account-group';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';

@Injectable({ providedIn: 'root' })
export class TagsService {
  tags$ = this.namespace$.pipe(
    switchMap((partnerId) =>
      this.accountGroupService.listOptionsForField({
        partnerId: partnerId,
        field: AggregationSupportedFields.AGGREGATION_TAGS,
      }),
    ),
  );

  constructor(
    private accountGroupService: AccountGroupSdkService,
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}
}
